import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from './firebase';
import { db } from './firebase'; // Assurez-vous d'importer db depuis firebase
import { doc, setDoc } from 'firebase/firestore';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import './Login.css';

const Login = ({ from }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pseudo, setPseudo] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Détermine la page de redirection (par défaut : '/')
  const redirectPath = from || location.state?.from || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    
    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
        navigate(redirectPath);
      } else {
        // Inscription
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        
        // Sauvegarder le pseudo dans Firestore
        await setDoc(doc(db, "users", user.uid), {
          pseudo: pseudo,
          email: email,
          createdAt: new Date()
        });
        
        navigate(redirectPath);
      }
    } catch (error) {
      console.error('Erreur lors de l\'authentification:', error.code, error.message);
      
      // Messages d'erreur simplifiés
      if (error.code === 'auth/invalid-email') {
        setError('Adresse email invalide');
      } else if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        setError('Email ou mot de passe incorrect');
      } else if (error.code === 'auth/weak-password') {
        setError('Mot de passe trop faible');
      } else if (error.code === 'auth/email-already-in-use') {
        setError('Cette adresse email est déjà utilisée');
      } else {
        setError('Une erreur est survenue');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const googleSignIn = async () => {
    setError(null);
    setIsLoading(true);
    
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      
      // Vérifier si c'est un nouvel utilisateur pour enregistrer le pseudo
      // Pour Google, on peut utiliser leur nom d'affichage comme pseudo par défaut
      if (result._tokenResponse.isNewUser) {
        await setDoc(doc(db, "users", user.uid), {
          pseudo: user.displayName || email.split('@')[0], // Utilise le nom d'affichage ou la partie locale de l'email
          email: user.email,
          createdAt: new Date()
        });
      }
      
      navigate(redirectPath);
    } catch (error) {
      console.error('Erreur lors de la connexion Google:', error.code, error.message);
      setError('Échec de la connexion avec Google');
    } finally {
      setIsLoading(false);
    }
  };

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setError(null); // Réinitialiser les erreurs lors du changement de mode
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h2 className="login-title">{isLogin ? 'Connexion' : 'Inscription'}</h2>
        
        <form className="login-form" onSubmit={handleSubmit}>
          {!isLogin && (
            <input 
              className="input-field"
              type="text" 
              placeholder="Pseudo" 
              value={pseudo} 
              onChange={(e) => setPseudo(e.target.value)} 
              required={!isLogin}
              disabled={isLoading}
            />
          )}
          
          <input 
            className="input-field"
            type="email" 
            placeholder="Email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
            disabled={isLoading}
          />
          
          <input 
            className="input-field"
            type="password" 
            placeholder="Mot de passe" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
            disabled={isLoading}
          />
          
          <button 
            className="login-button"
            type="submit" 
            disabled={isLoading}
          >
            {isLoading ? 'Chargement...' : isLogin ? 'Se connecter' : 'S\'inscrire'}
          </button>
        </form>
        
        <button 
          className="google-button" 
          onClick={googleSignIn} 
          disabled={isLoading}
        >
          <span>{isLoading ? 'Chargement...' : 'Se connecter avec Google'}</span>
        </button>
        
        <button 
          className="create-account-button" 
          onClick={toggleMode} 
          disabled={isLoading}
        >
          {isLogin ? 'Créer un compte' : 'Déjà un compte ?'}
        </button>
        
        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
};

export default Login;